<template>
  <div v-if="base.pageErrorTip.visible" class="page-error-tip">
    <div class="shadow"></div>
    <p class="message">{{ base.pageErrorTip.message }}</p>
  </div>
</template>

<script lang="ts" setup>
import { useBaseStore } from "@store/base";
const base = useBaseStore();
</script>

<style lang="scss" scoped>
@import "@assets/scss/_mixin.scss";
@import "@assets/scss/_dimen.scss";
.page-error-tip {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 1003;

  .shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.75);
  }

  .message {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 0 20px;
    font-size: $fzTitle;
    color: $maincolor;
    text-align: center;
    box-sizing: border-box;
    line-height: 40px;
  }
}
</style>
